export default "__VITE_ASSET__hT3lsSC9__"